/* MPS — "Aggiungi" in un tocco sui prodotti suggeriti del carrello (drawer).
   Aggiunge la variante via /cart/add.js e lancia on:cart:change: il drawer
   (cart-form), la barra spedizione e il contatore nell'header si aggiornano da soli
   e i suggeriti vengono ricaricati (il prodotto appena aggiunto sparisce dalla lista). */
(function () {
  if (window.mpsQuickAddBound) return;
  window.mpsQuickAddBound = true;

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('button.mps-quick-add[data-variant-id]');
    if (!btn || btn.disabled || btn.classList.contains('mps-quick-add--added')) return;
    evt.preventDefault();

    var label = btn.querySelector('.mps-quick-add__label');
    var idleText = label ? label.textContent : '';
    btn.disabled = true;
    btn.classList.add('mps-quick-add--loading');

    var url = (window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || ('HTTP ' + response.status));
          }
          return data;
        });
      })
      .then(function () {
        btn.classList.remove('mps-quick-add--loading');
        btn.classList.add('mps-quick-add--added');
        btn.disabled = false;
        if (label && btn.dataset.addedText) label.textContent = btn.dataset.addedText;
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
      })
      .catch(function (error) {
        btn.disabled = false;
        btn.classList.remove('mps-quick-add--loading');
        if (label) label.textContent = idleText;
        if (window.theme && typeof theme.showQuickPopup === 'function') {
          theme.showQuickPopup(error.message, btn);
        } else {
          console.log(error.message); // eslint-disable-line
        }
      });
  });
})();
